import LawFirms from "../../Assets/Images/Illustrations/user_law_firm.svg";
import CorporateIPCounsels from "../../Assets/Images/Illustrations/user_corporate_ip_counsel.svg";
import Inventors from "../../Assets/Images/Illustrations/user_inventor.svg";
import RDTeams from "../../Assets/Images/Illustrations/user_rd_team.svg";
import Enterprises from "../../Assets/Images/Illustrations/user_enterprise.svg";
import React from "react";
import "../../Pages/pages.css"

export const UseCaseDiagramList = {
    PrefilingSearches:{
        Title: "Who Uses IP Agent AI?",
        Diagrams: [
            {
                Name: "Patent Lawyers",
                Description: "Patent lawyers rely on IP Agent AI’s AI-powered novelty searches to uncover precise prior art, streamline drafting, and build stronger, rejection-resistant applications.",
                Icon: LawFirms,
            },
            {
                Name: "Corporate IP Counsels",
                Description: "Corporate IP counsels leverage IP Agent AI’s AI-powered novelty searches to detect prior early, reduce filing risks, an ensure stronger, defensible patents across their portfolios.",
                Icon: CorporateIPCounsels,
            },
            {
                Name: "Inventors & Enterprises",
                Description: "Inventors and enterprises turn to IP Agent AI’s AI-powered novelty searches to quickly uncover prior art, cut costs, and file stronger patents with confidence.",
                Icon: Inventors,
            },
            {
                Name: "R&D Teams",
                Description: "R&D teams rely on our patent pre-filing searches to validate product uniqueness, minimize risks, and optimize resources",
                Icon: RDTeams,
            },
        ]
    },
    InvaliditySearches:{
        Title: "Who Uses IP Agent AI for Invalidity Searches?",
        Diagrams: [
            {
                Name: "Law Firms",
                Description: "Patent lawyers trust IP Agent AI’s AI-powered invalidity searches to uncover precise prior art, streamline litigation preparation, and deliver litigation-ready insights that strengthen client defenses.",
                Icon: LawFirms,
            },
            {
                Name: "Corporate IP Counsels",
                Description: "Corporate counsels leverage IP Agent AI to identify weak competitor patents, minimize litigation exposure, and protect their company’s innovation pipeline with cost-effective invalidity searches.",
                Icon: CorporateIPCounsels,
            },
            {
                Name: "Enterprises",
                Description: "Enterprises rely on IP Agent AI’s invalidity searches to mitigate risks, reduce legal costs, and safeguard long-term market share with evidence-backed insights.",
                Icon: Enterprises,
            },
        ]
    },
    FirstDraft:{
        Title: "Who Uses IP Agent AI for Patent Drafts?",
        Diagrams: [
            {
                Name: "In-House Counsels",
                Description: "Generate first draft quickly, reduce outside counsel costs, and align filings with corporate IP strategy.",
                Icon: LawFirms,
            },
            {
                Name: "Outside Counsels",
                Description: "Accelerate drafting cut down billable hours spent on routine tasks, and deliver higher-quality applications",
                Icon: LawFirms,
            },

        ]
    },

}

export default class UseCaseDiagrams extends React.Component{
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    render() {
        let {info} = this.props;
        return (
            <div className="use-case-diagram">
                <h3 className="use-case-diagram-title">{info.Title}</h3>
                <div className="use-case-diagram-section-list">
                    {
                        info.Diagrams.map((res,index)=>
                        <div className="use-case-diagram-section">
                            <div className="use-case-diagram-icon">
                                <img src={res.Icon} alt={res.Name}/>
                            </div>
                            <div className="use-case-diagram-section-title">{res.Name}</div>
                            <div className="use-case-diagram-section-description">{res.Description}</div>
                        </div>
                        )
                    }
                </div>
            </div>
        )
    }
}
